<template>
  <div class="follow-company-wrapper container">

    <div class="progressBar">
      <WProgressBar width="100%" />
    </div>

    <!-- 标题 -->
    <div class="choose-layout" :style="selectedCompantList.length && 'marginBottom: 32px;'">
      <div class="choose-title2">
        <div class="choose-title-left2">选择感兴趣的公司</div>
        <div class="choose-title-right2" @click="jump()">不需要</div>
      </div>
       <div class="reminder2">推荐最适合你的简历模板~（可多选）</div>
    </div>

    <!-- 选择的公司 -->
    <div class="selected" v-if="selectedCompantList.length">
      <div class="selected-item" v-for="(itemSelect, indexSelect) in selectedCompantList" :key="`selectedCompany&${indexSelect}`" @click="toggleCompanyFunc(itemSelect)">
        <span>{{ itemSelect.name }}</span>
        <i class="iconfont iconshanchu1"></i>
      </div>
    </div>

    <!-- 公司列表 -->
    <div class="list">

      <div class="list-item" v-for="(itemCompany, indexCompany) in randomCompanyList" :key="`company&${indexCompany}`" @click="toggleCompanyFunc(itemCompany)">
        <img class="list-item-logo" :src="itemCompany.logo" alt="">
        <h6 class="list-item-title">{{ itemCompany.name }}</h6>
        <i class="list-item-icon iconfont iconwancheng" :class="itemCompany.active && 'opacity'"></i>
      </div>

    </div>

    <!-- 切换公司 -->
    <div class="change" @click="debounce(() => { getRandomCompanyList() }, 300)">
      <i class="iconfont iconhuanyihuan"></i>
      <span>换一换</span>
    </div>

    <!-- 底部按钮 -->
    <div class="bottom-layout">
      <div class="circle-btn" @click="prev()">
        <img src="https://files.wondercv.com/intention/ic_left_arrow.png" class="ic-btn" alt="">
      </div>
      <div class="circle-btn" :class="{active: selectedCompantList.length > 0}" @click="next()">
        <img :src="selectedCompantList.length > 0 ? 'https://files.wondercv.com/intention/ic_white_right_arrow.png' : 'https://files.wondercv.com/intention/ic_left_arrow.png'" 
          class="ic-btn" :class="{right: selectedCompantList.length === 0}" alt="">
      </div>
    </div>
      

  </div>
</template>

<script>
import WProgressBar from '@/components/global/w-progress-bar'
import { componentsMixin } from '@/assets/js/mixin/components'

export default {
  data () {
    return {
      selectedCompantList: [], // 已选择公司列表
      randomCompanyList: [], // 随机公司列表
    }
  },
  mixins: [ componentsMixin ],
  components: {
    WProgressBar
  },
  computed: {
    selectcompanyCheck () {
      return this.selectedCompantList.length >= 5
    }
  },
  created () {
    this.getRandomCompanyList()
  },
  methods: {
    jump () {
      this.$router.push('/cvs')
    },
    async next () {
      try {

        if (!this.selectedCompantList.length) {
          this.$message.warning('请关注一个公司')
          return
        }

        let arr = this.selectedCompantList.map((item) => item.token)
        let params = {
          company_token_list: arr
        }
        let res = await this.$api.jobs.batchFollowCompany(params)
        if (res.code === 1000) {
          this.$router.push('/cvs')
        }
      } catch (error) {
        console.log(error)
      }
    },
    prev () {
      this.$router.go(-1)
    },
    // 添加公司
    toggleCompanyFunc (data) {
      // 删除
      if (data.active) {
        data.active = false
        this.deleteSelectCompanyFunc(data.token)
      // 添加
      } else {
        // 检查选择数量
        if (this.selectcompanyCheck) return this.showToast('最多选择五个')
        data.active = true
        this.selectedCompantList.push(data)
      }
    },
    // 删除选择的公司
    deleteSelectCompanyFunc (token) {
      this.selectedCompantList.forEach((item, index) => {
        if (item.token === token) {
          this.selectedCompantList.splice(index, 1)
        }
      })
    },
    // 获取随机公司数据
    async getRandomCompanyList () {
      try {
        let res = await this.$api.jobs.getRandomCompanyList()
        if (res.code === 1000) {
          this.randomCompanyList = res.data.all_company || []
          // 同步活跃公司
          if (!this.selectedCompantList.length) return
          this.selectedCompantList.forEach((item1, index1) => {
            this.randomCompanyList.forEach((item2, index2) => {
              if (item1.token === item2.token) {
                item2.active = true
                this.selectedCompantList.splice(index1, 1, item2)
              }
            })
          })
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  .follow-company-wrapper  {
    .progressBar {
      width: 100%;
      position: absolute;
      top: 16px;
      padding: 0 24px;
    }

    .choose-layout {
      -webkit-flex: 1 0 auto; 
      display: flex;
      flex-direction: column;
      padding: 70px 24px 0px 24px;
      margin: 0px 0px 42px 0px;
      .choose-title2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 0px 8px 0px;
        .choose-title-left2 {
          font-size: 24px;
          color: #404040;
          font-weight: 600;
        }
        .choose-title-right2 {
          font-size: 14px;
          font-weight: 400;
          color: #CFCFCF;
        }
        }
      .reminder2 {
        color: #9C9C9C;
        font-size: 14px;
        font-weight: 400;
        // margin-bottom: 48px;
      }
    }

    .subtitle {
      font-size: 14px;
      font-weight: 400;
      color: #9C9C9C;
      line-height: 14px;
      text-align: center;

      &.active {
        margin-bottom: 54px;
      }
    }

    .selected {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 32px;
      margin-bottom: 24px;
      padding: 0 24px;

      .selected-item {
        padding: 8px 10px 8px 16px;
        border: 1px solid #ff6644;
        margin-right: 8px;
        cursor: pointer;
        margin-bottom: 6px;
        border-radius: 16px;

        &:last-of-type {
          margin-right: 0;
        }

        >span {
          font-size: 14px;
          font-weight: 400;
          color: #FF6644;
          line-height: 14px;
          margin-right: 10px;
        }

        >i {
          color: #ff6644;
          font-size: 14px;
        }
      }
    }

    .list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 24px;

      .list-item {
        width: 48%;
        display: flex;
        align-items: center;
        background: #FFFFFF;
        box-shadow: 0px 2px 18px 0px rgba(5, 32, 82, 0.08);
        border-radius: 8px;
        margin-bottom: 11px;
        padding: 16px;
        box-sizing: border-box;

        .list-item-logo {
          width: 32px;
          height: 32px;
          border-radius: 4px;
          border: 1px solid #F9F9F9;
          object-fit: cover;
          object-position: center;
          margin-right: 10px;
        }

        .list-item-title {
          flex: 1;
          font-size: 16px;
          font-weight: 500;
          color: #404040;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 2px;
        }

        .list-item-icon {
          font-size: 16px;
          color: #ff6644;
          opacity: 0;

          &.opacity {
            opacity: 1;
          }
        }

      }
    }

    .change {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 13px;
      padding: 0 24px;

      >i {
        color: #4183ff;
        font-size: 14px;
        margin-right: 8px;
      }

      >span {
        font-size: 13px;
        font-weight: 400;
        color: #404040;
        line-height: 18px;
      }
    }

    .bottom-layout {
      position: absolute;
      bottom: 0;
      width: calc(100% - 48px) ;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin: 24px;
      .circle-btn {
        display: flex;
        width: 64px;
        height: 64px;
        background: #F9F9F9;
        border: 1px solid #F4F4F4;
        border-radius: 32px;
        justify-content: center;
        align-items: center;
        .ic-btn {
          width: 12px;
          height: 20px;
          &.right{
            transform: rotate(180deg);
          }
        }
        &.active {
          background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
          box-shadow: 0px 6px 24px -8px #FF6644;
          border: none;
        }
      }
    }

  }
</style>
